import { createSlice } from "@reduxjs/toolkit"
import { LocationKitchen } from "./reports/home/weekMenuTypes"
import type { PayloadAction } from "@reduxjs/toolkit"

type NonAdminUserState = {
    selectedKitchen: LocationKitchen | null
}

const initialState: NonAdminUserState = {
    selectedKitchen: null,
}

const nonAdminUserSlice = createSlice({
    name: "nonAdminUser",
    initialState,
    reducers: {
        setSelectedKitchen: (state, action: PayloadAction<LocationKitchen>) => {
            state.selectedKitchen = action.payload
        },
    },
})

export const { setSelectedKitchen } = nonAdminUserSlice.actions
export const nonAdminUserReducer = nonAdminUserSlice.reducer
